import * as React from 'react'
import Svg, { Path } from 'react-native-svg'
import { Props } from './type'
export const WarningIcon = (props: Props) => (
  <Svg viewBox='0 0 37 33' fill='none' {...props}>
    <Path
      d='M18.4998 7.31675L31.0498 29.0001L5.94984 29.0001L18.4998 7.31675ZM18.4998 0.666748L0.166504 32.3334L36.8332 32.3334L18.4998 0.666748ZM20.1665 24.0001L16.8332 24.0001L16.8332 27.3334L20.1665 27.3334L20.1665 24.0001ZM20.1665 14.0001L16.8332 14.0001L16.8332 20.6667L20.1665 20.6667L20.1665 14.0001Z'
      fill='#FE5000'
    />
  </Svg>
)
